<template>
    <div class="video-edit-con">
        <div class="video-uploading">
            <label class="video-uploading-btn f-inlineblock-top" for="file-selector">
                <span class="g-input js-upload-input"> </span>
                <p class="btn-text" id="video_btn">上传视频</p>
            </label>
            <input id="file-selector" ref="videoInput" class="f-hide" type="file" accept="video/*" @change="addFile($event)">
            <p class="uploading-prompt f-inlineblock-top">上传视频，可将视频发布到更多媒体哦，单个视频限制2G。</p>
        </div>
        <!-- 视频上传中的状态[[ -->
        <div class="video-uploading-block" 
            v-loading="loading"
            element-loading-spinner="el-icon-loading" 
            >
            <div class="shacurr" 
                v-loading="shacurr"  
                element-loading-spinner="el-icon-loading"
                :element-loading-text="'校验中：'+shacurr+'%'"
                v-show="shacurr">
            </div>
            <div class="video-name" v-show="fileName != ''" >{{fileName}}</div>
            <div v-show="uploadStatus == 2 || uploadStatus == 3">
                <div class="progress-content">
                    <div class="progress-bar">
                        <div class="bar" :style="{width:progressBar + '%'}"></div>
                        <div class="progress"></div>
                    </div>
                    <!-- 上传中显示 -->
                    <a class="g-btn video-cancel" v-show="uploadStatus == 2" href="javascript:;" @click="delVideo">取消</a>
                    
                    <!-- 上传加载完显示 -->
                    <label for="file-selector" class="g-btn reupload" v-show="uploadStatus == 3" href="javascript:;">重新上传</label>
                </div>
                <div class="progress-tips">
                    <span class="tips-name" v-show="uploadStatus == 2">已上传：</span>
                    <span class="tips-content" v-show="uploadStatus == 2">{{uploadedFileSize}}/{{conver(fileSize)}}</span>
                </div>
                
                <!-- 上传中显示 start -->
                <div class="progress-tips speed" v-show="uploadStatus == 2">
                    <span class="tips-name">速度：</span>
                    <span class="tips-content">{{speed}}/s</span>
                </div>
                <div class="progress-tips surplus-time" v-show="uploadStatus != 3">
                    <span class="tips-name">剩余时间：</span>
                    <span class="tips-content">{{waitTime}}</span>
                </div>
                <!-- 上传中显示 end -->
                
                <!-- 只有上传加载完的状态才显示 -->
                <div class="progress-tips video-len" v-show="uploadStatus == 3">
                    <p class="tips-text f-inlineblock-top">上传完成</p>
                    <video class="f-hide" ref="videoRef" :src="previewUrl" width="200" height="150" controls>
                        <!-- <source src="~Assets/img/v1.mp4" type="video/mp4" /> -->
                        当前浏览器不支持 video直接播放
                    </video>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import '~Assets/sass/pages/v4/contribute/task.scss';
    .bar{
        transition: linear 0.1s;
    }
    .video-uploading-block{
        position: relative;
    }
    .shacurr{
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 1;
    }
</style>
<script>
import  videoUploadUgc  from 'Mixins/videoUploadUgc';
export default {
    mixins: [videoUploadUgc]
}
</script>